const normalizeUsersPayload = (payload) => {
  if (Array.isArray(payload)) {
    return payload;
  }

  if (Array.isArray(payload?.items)) {
    return payload.items;
  }

  if (Array.isArray(payload?.users)) {
    return payload.users;
  }

  if (Array.isArray(payload?.data)) {
    return payload.data;
  }

  return [];
};

const normalizeUserRecord = (user) => {
  if (!user || typeof user !== 'object') {
    return null;
  }

  const normalizedId = String(user._id || user.email || '').trim();
  if (!normalizedId) {
    return null;
  }

  if (user._id) {
    return user;
  }

  return {
    ...user,
    _id: normalizedId,
  };
};

const normalizeUsersList = (payload) =>
  normalizeUsersPayload(payload).map(normalizeUserRecord).filter(Boolean);

export default {
  SET_CURRENT_USER: (state, userData) => {
    state.currentUser = userData;
  },
  SET_USERS: (state, users) => {
    const oilUserEmail = String(process.env.VUE_APP_OIL_USER_EMAIL || '')
      .trim()
      .toLowerCase();
    const normalizedUsers = normalizeUsersList(users);
    const filteredUsers = oilUserEmail
      ? normalizedUsers.filter(
          (user) =>
            String(user._id || '')
              .trim()
              .toLowerCase() !== oilUserEmail
        )
      : normalizedUsers;

    state.users = filteredUsers;
  },
  SET_USERS_PENDING_APPROVAL: (state, users) => {
    state.usersPendingApproval = normalizeUsersList(users);
  },
  SET_USERS_LOGGED_IN_TODAY: (state, users) => {
    state.usersLoggedInToday = normalizeUsersList(users);
  },
  SET_USERS_REJECTED: (state, users) => {
    state.usersRejected = normalizeUsersList(users);
  },
  SET_USERS_WITHOUT_SEPIA_INFO: (state, users) => {
    state.usersWithoutSepiaInfo = normalizeUsersList(users);
  },
  UPDATE_USER_IN_LISTS: (state, userToUpdate) => {
    const updateList = (list) => {
      const index = list.findIndex((user) => user._id === userToUpdate._id);
      if (index >= 0) {
        list.splice(index, 1, { ...list[index], ...userToUpdate });
      }
    };

    updateList(state.users);
    updateList(state.usersPendingApproval);
    updateList(state.usersLoggedInToday);
    updateList(state.usersRejected);
    updateList(state.usersWithoutSepiaInfo);
  },
};
